import {debounce} from "../tools/tools";


export default class initBackToTop {

    constructor() {

        this.floatingCTA = document.querySelector('.cp-back-to-top');

        if(!this.floatingCTA || this.floatingCTA === undefined) {
            return
        }

        this.floatingCTA.addEventListener("click", this.topFunction.bind(this));
    }

    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

}
